export default "/assets/images/app-screen3.dc7ec402d01b1a02.webp";